import "./App.css";
import "./scorecardtheme.css";
import WalletPage from "./components/WalletComponents/WalletPage";
import DefaultPage from "./components/DefaultPage";
import SportsPage from "./components/SportsPage";
import WalletInfo from "./components/WalletComponents/WalletInfo";
import Footer from "./components/WalletComponents/Footer";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NoAccessPage from "./components/no-access";
import IframePage from "./components/pages/IframePage";
import ProfilePage from "./components/WalletComponents/ProfilePage";
import TransactionHistory from "./components/WalletComponents/TransactionHistory/TransactionHistory";
import TransactionHistoryDetails from "./components/WalletComponents/TransactionHistory/TransactionHistoryDetails";
import CasinoIframe from "./components/pages/CasinoIframe";
import Site from "./components/pages/Site";
import HomePage from "./components/Home/Home";
import PlayGame from "./components/pages/PlayGame";
import BannerInfo from "./components/BannerInfo/BannerInfo";
import RaffleInfo from "./components/pages/RaffleInfo";
import ProviderGames from "./components/ProviderGames/ProviderGames";
import { useEffect, useState, useRef, useLayoutEffect } from "react";
// import Loader from "../src/assets/images/Strike_White_Logo_Transparent_GIF.gif";
import { Backdrop } from "@mui/material";
import MyProfile from "./components/WalletComponents/MyProfile/MyProfile";
import IplThemes from "./components/WalletComponents/MyProfile/IplThemes";
import "./theme/variables.css"
import CustomerSupport from "./components/pages/CustomerSupport/CustomerSupport";
import TicketDetails from "./components/pages/CustomerSupport/TicketDetails";
import Notifications from "./components/pages/Notifications/Notifications";
import BetList from "./components/pages/BetList/BetList";
import AccountStatement from "./components/pages/AccountStatement/AccountStatement";
import SiteAccountStatement from "./components/pages/SiteAccountStatement/SiteAccountStatement";
import FAQ from "./components/pages/FAQ/FAQ";
import NewTicket from "./components/pages/CustomerSupport/NewTicket";
import ContentPage from "./components/pages/ContentPage/ContentPage";
import ContactUs from "./components/pages/ContactUs/ContactUs";
import BetDetails from "./components/pages/BetList/BetDetails";
import EventsPage from "./components/EventsPage/EventsPage";
import ExchangeMarketsPage from "./components/ExchangeMarketsPage/ExchangeMarketsPage";
import WagerList from "./components/pages/WagerList/WagerList";
import PrivacyPolicy from "./components/pages/PrivacyPolicy/PrivacyPolicy";
import SportsBookMarketPage from "./components/SportsBookMarketPage/SportsBookMarketPage";
import { getRefId, getUserBalance, siteConfig } from "./store/authActions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "./store/store";
import { useAuth } from "./hooks/hook";
import Logout from "./components/Logout";
import SpinTab from "./components/WalletComponents/SpinTab";
import SeeAll from "./components/SeeAll/SeeAll";
import LoginPage from "./components/Login";
import { setBrowser, setIsLoggedIn } from "./store/authReducer";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import LoginWrapper from "./components/LoginWrapper";
import RegisterWrapper from "./components/RegisterWrapper";
import Promotions from "./components/pages/Promotions";
import CreateWhitelabel from "./components/pages/Whitelabel/CreateWhitelabel";
import CreateWhitelabelTourPage from "./components/guides/createWhitelabel/CreateWhitelabelTourPage";
import WhitelabelPaymentHelpTourPage from "./components/guides/whitelabelPaymentHelp/WhitelabelPaymentHelpTourPage";
import AddFundsHelpTourPage from "./components/guides/addFundsHelp/AddFundsHelpTourPage";
import Whitelabels from "./components/pages/Whitelabel/Whitelabels";
import PendingWhitelabelDetails from "./components/pages/Whitelabel/PendingWhitelabelDetails";
import WhitelabelAddFundsPackages from "./components/pages/Whitelabel/WhitelabelAddFundsPackages";
import WhitelabelTransactions from "./components/pages/Whitelabel/WhitelabelTransactions";
import LowBalancePopup from "./components/LowBalancePopup";
import EmptyUserIdPopup from "./components/EmptyUserIdPopup";
import SocialMediaIcons from "./components/SocialMediaIcons";
import { BRAND_NAME, domain } from "./constants/Branding";
import { shouldShowWagerNotice } from "./constants/common";
import { getEnvVariable, Loader } from "./constants/whitelabelEnv";
import { demoUser } from "./utils/StringUtils";
import Sitemap from "./components/SiteMap";
import AlertHomePopup from "./components/AlertPopup";
import WagerNoticeDialog from "./components/WagerNoticeDialog/WagerNoticeDialog";

interface TelegramUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  start_param?: string;
}

export interface DateRange{
  start_time: number;
  end_time: number;
}

const loadTheme = () => {
  const cssFolderName = getEnvVariable(domain, 'FOLDER_NAME') || 'default';
  const cssFilePath = `/theme/default/variables.css`;

  // Check if an existing theme file is already loaded

  console.log("cssFilePath", cssFilePath);
  let existingLink = document.getElementById('site-theme');

  if (existingLink) {
    // Replace existing theme
    existingLink.setAttribute('href', cssFilePath);
  } else {
    // Create new theme link
    const link = document.createElement('link');
    link.id = 'site-theme';
    link.rel = 'stylesheet';
    link.href = cssFilePath;
    document.head.appendChild(link);
  }

  console.log(`Loaded theme: ${cssFolderName}`);
};

const updateFavicon = () => {
  let link: any = document.querySelector("link[rel~='icon']");

  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }

  link.setAttribute('href', getEnvVariable(domain, 'favicon'));
};

const updateTitle = () => {
  document.title = BRAND_NAME;
};

const updateOpenGraphTags = () => {
  const brandName = getEnvVariable(domain, 'BRAND_NAME');
  
  // Only apply dynamic Open Graph tags for Hindu777 brand
  if (brandName !== 'Hindu777') {
    return;
  }
  
  const brandDomain = getEnvVariable(domain, 'BRAND_DOMAIN');
  const logo = getEnvVariable(domain, 'logo');
  const favicon = getEnvVariable(domain, 'favicon');
  
  // Update or create Open Graph meta tags
  const updateOrCreateMetaTag = (property: string, content: string) => {
    let metaTag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
    if (!metaTag) {
      metaTag = document.createElement('meta');
      metaTag.setAttribute('property', property);
      document.head.appendChild(metaTag);
    }
    metaTag.setAttribute('content', content);
  };

  // Update or create Twitter Card meta tags
  const updateOrCreateTwitterTag = (name: string, content: string) => {
    let metaTag = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
    if (!metaTag) {
      metaTag = document.createElement('meta');
      metaTag.setAttribute('name', name);
      document.head.appendChild(metaTag);
    }
    metaTag.setAttribute('content', content);
  };

  // Open Graph tags
  updateOrCreateMetaTag('og:title', brandName);
  updateOrCreateMetaTag('og:description', `For fun games and exciting awards - ${brandName}`);
  updateOrCreateMetaTag('og:image', `${window.location.origin}/${logo}`);
  updateOrCreateMetaTag('og:url', window.location.href);
  updateOrCreateMetaTag('og:type', 'website');
  updateOrCreateMetaTag('og:site_name', brandName);

  // Twitter Card tags
  updateOrCreateTwitterTag('twitter:card', 'summary_large_image');
  updateOrCreateTwitterTag('twitter:title', brandName);
  updateOrCreateTwitterTag('twitter:description', `For fun games and exciting awards - ${brandName}`);
  updateOrCreateTwitterTag('twitter:image', `${window.location.origin}/${logo}`);

  // Additional meta tags for better sharing
  updateOrCreateMetaTag('og:image:width', '1200');
  updateOrCreateMetaTag('og:image:height', '630');
  updateOrCreateMetaTag('og:image:alt', `${brandName} Logo`);
};

const updateManifest = () => {
  const brandName = getEnvVariable(domain, 'BRAND_NAME');
  
  // Only apply dynamic manifest updates for Hindu777 brand
  if (brandName !== 'Hindu777') {
    return;
  }
  
  const favicon = getEnvVariable(domain, 'favicon');
  
  // Update manifest.json dynamically
  fetch('/manifest.json')
    .then(response => response.json())
    .then(manifest => {
      // Update manifest with brand-specific information
      manifest.name = brandName;
      manifest.short_name = brandName;
      manifest.icons = [
        {
          src: favicon,
          sizes: "64x64 32x32 24x24 16x16",
          type: "image/png"
        },
        {
          src: favicon,
          type: "image/png",
          sizes: "192x192"
        },
        {
          src: favicon,
          type: "image/png",
          sizes: "512x512"
        }
      ];
      
      // Update the manifest link in the head
      let manifestLink = document.querySelector('link[rel="manifest"]') as HTMLLinkElement;
      if (manifestLink) {
        // Create a blob URL for the updated manifest
        const blob = new Blob([JSON.stringify(manifest, null, 2)], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        manifestLink.href = url;
      }
    })
    .catch(error => {
      console.error('Error updating manifest:', error);
    });
};

// Initialize Meta Pixel only for Hindu777 whitelabel
const initMetaPixelIfHindu777 = () => {
  try {
    const brandName = getEnvVariable(domain, 'BRAND_NAME');
    if (brandName !== 'Hindu777') return;

    if (document.getElementById('meta-pixel')) return;

    const script = document.createElement('script');
    script.id = 'meta-pixel';
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.onload = () => {
      try {
        (window as any).fbq('init', '648599238086112');
        (window as any).fbq('track', 'PageView');
      } catch (e) {
        console.error('Meta Pixel initialization failed after load:', e);
      }
    };

    // Predefine fbq queue before script loads (optional but safe)
    const w: any = window;
    if (!w.fbq) {
      const fbq: any = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      } as any;
      fbq.push = fbq;
      fbq.loaded = false;
      fbq.version = '2.0';
      fbq.queue = [];
      w.fbq = fbq;
    }

    document.head.appendChild(script);
  } catch (err) {
    console.error('Failed to initialize Meta Pixel:', err);
  }
};

// Initialize Meta Pixel only for bidexch whitelabel
const initMetaPixelIfBidexch = () => {
  try {
    const brandName = getEnvVariable(domain, 'BRAND_NAME');
    if (brandName?.toLowerCase() !== 'bidexch') return;

    if (document.getElementById('meta-pixel-bidexch')) return;

    // Meta Pixel Code (bidexch only)
    ((f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) => {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];

      t = b.createElement(e);
      t.id = 'meta-pixel-bidexch';
      t.async = true;
      t.src = v;

      s = b.getElementsByTagName(e)[0];
      s?.parentNode?.insertBefore(t, s);
      if (!s?.parentNode) b.head.appendChild(t);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    (window as any).fbq('init', '795914086903812');
    (window as any).fbq('track', 'PageView');

    // Add noscript fallback image
    if (!document.getElementById('meta-pixel-noscript-bidexch')) {
      const noscript = document.createElement('noscript');
      noscript.id = 'meta-pixel-noscript-bidexch';
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=795914086903812&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }
  } catch (err) {
    console.error('Failed to initialize Meta Pixel for bidexch:', err);
  }
};

// Initialize Zoho SalesIQ only for ShivShaktiGaming whitelabel
const initZohoSalesIQIfShivShaktiGaming = () => {
  try {
    //ShivShaktiGaming
    const brandName = getEnvVariable(domain, 'BRAND_NAME');
    if (brandName?.toLowerCase() !== 'shivshaktigaming') return;

    if (document.getElementById('zsiqscript')) return;

    // Setup Zoho global object
    const w: any = window;
    w.$zoho = w.$zoho || {};
    w.$zoho.salesiq = w.$zoho.salesiq || { ready: function () {} };

    // Add the Zoho SalesIQ script
    const script = document.createElement('script');
    script.id = 'zsiqscript';
    script.src = 'https://salesiq.zohopublic.com/widget?wc=siq9fcc585985b633759e41eac8fcc55b370e7ec2c41de6040b09f2ed0d6db91ee3';
    script.defer = true;
    document.head.appendChild(script);
  } catch (err) {
    console.error('Failed to initialize Zoho SalesIQ for ShivShaktiGaming:', err);
  }
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="wallet" element={<WalletPage />} />
      <Route path="sports" element={<SportsPage />} />
      <Route path="casino" element={<CasinoIframe />} />
      <Route path="site" element={<Site />} />
      <Route path="iframe" element={<IframePage />} />
      <Route path="profile" element={<ProfilePage />} />
      <Route path="transactions" element={<TransactionHistory />} />
      <Route path="home" element={<HomePage />} />
      <Route path="play/:gameInfo" element={<PlayGame />} />
      <Route path="bannerinfo" element={<BannerInfo />} />
      <Route path="raffleinfo" element={<RaffleInfo />} />
      <Route path="providergames" element={<ProviderGames />} />
      <Route path="myprofile" element={<MyProfile />} />
      <Route path="ipl-themes" element={<IplThemesGuard><IplThemes /></IplThemesGuard>} />
      <Route path="customersupport" element={<CustomerSupport />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/ticket-details" element={<TicketDetails />} />
      <Route path="/notifications" element={<Notifications />} />
      <Route path="/betlist" element={<BetList />} />
      <Route path="/account-statement" element={<AccountStatement />} />
      <Route path="/site-account-statement" element={<SiteAccountStatement />} />
      <Route path="/transaction-history-details" element={<TransactionHistoryDetails />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/new-ticket" element={<NewTicket />} />
      <Route path="/bet-details" element={<BetDetails />} />
      <Route path="/privacypolicy" element={<ContentPage tag="PRIVACY_POLICY" title="Privacy Policy" />} />
      <Route path="/rules" element={<ContentPage tag="RULES_REGULATIONS" title="Rules & Regulations" />} />
      <Route path="/trustworthy" element={<ContentPage tag="TRUSTWORTHY" title="Trustworthy" />} />
      <Route path="/about" element={<ContentPage tag="ABOUT_US" title="About Us" />} />
      <Route path="/responsible-gambling" element={<ContentPage tag="RESPONSIBLE_GAMBLING" title="Responsible Gambling" />} />
      <Route path="/exclusion" element={<ContentPage tag="EXCLUSION_POLICY" title="Exclusion Policy" />} />
      <Route path="/terms" element={<ContentPage tag="TERMS_CONDITIONS" title="Terms & Conditions" />} />
      <Route path="/events/:gameInfo" element={<EventsPage />} />
      <Route path="/markets/:gameInfo" element={<ExchangeMarketsPage />} />
      <Route path="/sb-markets/:gameInfo" element={<SportsBookMarketPage />} />
      <Route path="/wager-list" element={<WagerList />} />
      <Route path="/see-all" element={<SeeAll />} />
      <Route path="/promotions" element={<Promotions />} />
      <Route path="/sitemap.xml" element={<Sitemap />} />
      <Route path="/whitelabel" element={<Whitelabels />} />
      <Route path="/whitelabel/create/tour" element={<CreateWhitelabelTourPage />} />
      <Route path="/whitelabel/help/payment-tour" element={<WhitelabelPaymentHelpTourPage />} />
      <Route path="/whitelabel/help/add-funds-tour" element={<AddFundsHelpTourPage />} />
      <Route path="/whitelabel/create" element={<CreateWhitelabel />} />
      <Route path="/whitelabel/details/:whitelabelId" element={<PendingWhitelabelDetails />} />
      <Route path="/whitelabel/add-funds" element={<WhitelabelAddFundsPackages />} />
      <Route path="/whitelabel/transactions" element={<WhitelabelTransactions />} />
      <Route path="/*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
};

const IplThemesGuard = ({ children }: { children: React.ReactElement }) => {
  const siteConfig = useSelector((state: RootState) => state.userDetails?.siteConfig);
  if (!siteConfig?.isIplThemeEnabled) {
    return <Navigate to="/myprofile" replace />;
  }
  return children;
};

// Component for handling loader with image preloading
const LoaderComponent = ({ domain }: { domain: string }) => {
  // Check if this is a domain that should use the enhanced loading
  const shouldUseEnhancedLoader = true;
  
  // Always call hooks unconditionally
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [loaderSrc, setLoaderSrc] = useState<string>('');
  
  // Get loader source immediately
  useEffect(() => {
    try {
      const src = Loader(domain);
      setLoaderSrc(src);
    } catch (error) {
      console.error('Error getting loader source:', error);
      setImageError(true);
    }
  }, [domain]);

  // Preload the image when source is available (only for enhanced domains)
  useEffect(() => {
    if (!shouldUseEnhancedLoader || !loaderSrc) return;

    const img = new Image();
    
    img.onload = () => {
      console.log('✅ Loader image loaded successfully:', loaderSrc);
      setImageLoaded(true);
    };
    
    img.onerror = () => {
      console.error('❌ Failed to load loader image:', loaderSrc);
      setImageError(true);
    };
    
    img.src = loaderSrc;
  }, [loaderSrc, shouldUseEnhancedLoader]);

  // For domains that should use enhanced loading
  if (shouldUseEnhancedLoader) {
    // Show a clean loading placeholder while the image loads
    if (!imageLoaded || imageError) {
      return (
        <div className="home-loading">
          <div 
            style={{ 
              height: '10rem', 
              width: '10rem',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '14px',
              border: '2px solid rgba(255, 255, 255, 0.2)',
              animation: 'pulse 1.5s ease-in-out infinite'
            }}
          >
            <div style={{ textAlign: 'center' }}>
              <div style={{ 
                width: '40px', 
                height: '40px', 
                border: '3px solid rgba(255, 255, 255, 0.3)',
                borderTop: '3px solid white',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                margin: '0 auto 10px'
              }}></div>
              Loading...
            </div>
          </div>
        </div>
      );
    }

    // Show the actual loader image once it's loaded
    return (
      <div className="home-loading">
        <img 
          src={loaderSrc} 
          style={{ height: '10rem' }} 
          alt="Loading..." 
          onError={(e) => {
            console.error('Image failed to display after preload:', loaderSrc);
            setImageError(true);
          }}
        />
      </div>
    );
  }

  // For all other domains, use the original implementation
  const originalLoaderSrc = Loader(domain);
  return (
    <div className="home-loading">
      <img src={originalLoaderSrc} style={{ height: '10rem' }} alt="Loading..." />
    </div>
  );
};

const ConditionalRoutes = () => {
  const location = useLocation();
  const path = location.pathname;
  const dispatch = useDispatch<AppDispatch>();
  const key = new URLSearchParams(window.location.search).get("id");
  const [user, setUser] = useState<any>();
  const navigate = useNavigate();
  const [showWagerNotice, setShowWagerNotice] = useState(false);
  const [pendingWagerGameLink, setPendingWagerGameLink] = useState("");
  const [blockPopupOpen, setBlockPopupOpen] = useState(false);
  const { isBlocked } = useAuth();
  const [lowBalancePopupOpen, setLowBalancePopupOpen] = useState(false);
  const [postLoginAlertTick, setPostLoginAlertTick] = useState(0);
  const [userIdReveal, setUserIdReveal] = useState(false);
  const wallets = useSelector((state: RootState) => state.userDetails?.wallets || []);
  const siteConfig = useSelector((state: RootState) => state.userDetails?.siteConfig);
  const detailUser = useSelector((state: RootState) => state.userDetails.userDetails);
  const browserChannel = useSelector((state: RootState) => state.userDetails.Browser);
  const apkUrl = (siteConfig?.apkUrl || "").trim();
  const [apkPopupOpen, setApkPopupOpen] = useState(false);
  const apkPopupPaths = ["/home", "/casino", "/sports", "/promotions"];
  const isAndroidDevice = /android/i.test(navigator.userAgent || "");
  const isIphoneDevice = /iphone|ipad|ipod/i.test(navigator.userAgent || "");
  const shouldAllowApkPopupOnPath = apkPopupPaths.some((apkPath) => path === apkPath || path.startsWith(apkPath + "/"));
  const shouldShowApkPopup = isAndroidDevice && !isIphoneDevice && shouldAllowApkPopupOnPath;
  
  // Use refs to track state without causing re-renders
  const popupCheckedRef = useRef<boolean>(false);
  const lastBalanceRef = useRef<number | null>(null);
  const lastPathRef = useRef<string>("");
  const checkTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const balanceFetchedRef = useRef<boolean>(false);
  const [alertReady, setAlertReady] = useState(false);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);


  // Combined effect: Reset refs, fetch balance, and check/show low balance popup
  useEffect(() => {
    // Only show popup for Winfast99 brand
    if (BRAND_NAME !== 'Winfast99') {
      // Close popup if open for non-Winfast99 brands
      if (lowBalancePopupOpen) {
        setLowBalancePopupOpen(false);
      }
      popupCheckedRef.current = false;
      return;
    }

    const pathsToCheck = ["/home", "/sports", "/casino", "/site"];
    const shouldCheck = pathsToCheck.some((p) => path === p || path.startsWith(p + "/"));
    
    // 1. Reset refs when session is reset (login/logout/TG reopen)
    const popupClosed = sessionStorage.getItem("lowBalancePopupClosed");
    const isSessionReset = !popupClosed;
    
    if (isSessionReset) {
      // Session was reset - clear popup-related refs when sessionStorage is cleared
      popupCheckedRef.current = false;
      lastBalanceRef.current = null;
      // Reset balanceFetchedRef only if this is the first check after reset
      // (indicated by lastPathRef being empty or different from current path)
      if (!lastPathRef.current || lastPathRef.current !== path) {
        balanceFetchedRef.current = false;
      }
    }

    // 2. Fetch balance first when navigating to specific paths
    if (shouldCheck) {
      // Reset balance fetched flag when path changes to ensure fresh fetch
      if (lastPathRef.current !== path) {
        balanceFetchedRef.current = false;
      }
      
      // Fetch balance first before checking (only if not already fetched for this path)
      if (!balanceFetchedRef.current) {
        balanceFetchedRef.current = true;
        dispatch(getUserBalance());
      }
    } else {
      // Reset balance fetched flag when leaving these paths
      balanceFetchedRef.current = false;
      // Close popup if open when leaving these paths
      if (lowBalancePopupOpen) {
        setLowBalancePopupOpen(false);
      }
      popupCheckedRef.current = false;
      return;
    }

    // 3. Check balance and show popup if POINTS wallet balance is 0
    // This runs after getUserBalance is called and wallets are updated
    
    // Hide popup for demo users
    if (demoUser()) {
      if (lowBalancePopupOpen) {
        setLowBalancePopupOpen(false);
      }
      popupCheckedRef.current = false;
      return;
    }

    // Check if popup was already closed in sessionStorage
    const popupClosedInStorage = sessionStorage.getItem("lowBalancePopupClosed") === "true";
    
    // If sessionStorage was cleared (login/logout) but ref still shows checked, reset it
    if (!popupClosedInStorage && popupCheckedRef.current) {
      popupCheckedRef.current = false;
      lastBalanceRef.current = null;
      lastPathRef.current = "";
    }
    
    if (popupClosedInStorage) {
      if (lowBalancePopupOpen) {
        setLowBalancePopupOpen(false);
      }
      popupCheckedRef.current = true; // Mark as checked
      return;
    }

    // Wait for wallets to be loaded (balance must be fetched first)
    if (wallets.length === 0) {
      return;
    }

    const pointsWallet = wallets.find((wallet: any) => wallet?.walletName === "POINTS");
    
    // Ensure pointsWallet exists and balance is a valid number
    // This ensures balance has been fetched and is not undefined/null
    if (!pointsWallet || pointsWallet.balance === undefined || pointsWallet.balance === null) {
      // Balance not loaded yet, don't show popup
      if (lowBalancePopupOpen) {
        setLowBalancePopupOpen(false);
      }
      return;
    }

    const currentBalance = pointsWallet.balance;
    
    // Skip if we've already checked this balance on this path
    if (popupCheckedRef.current && 
        currentBalance === lastBalanceRef.current && 
        path === lastPathRef.current) {
      return;
    }
    
    // Update refs
    lastBalanceRef.current = currentBalance;
    lastPathRef.current = path;
    
    // Only show popup if balance is EXACTLY 0 (strict check)
    if (currentBalance === 0) {
      // Only show if not already shown
      if (!popupCheckedRef.current) {
        // Clear any existing timeout
        if (checkTimeoutRef.current) {
          clearTimeout(checkTimeoutRef.current);
        }
        
        // Small delay to ensure smooth transition
        checkTimeoutRef.current = setTimeout(() => {
          setLowBalancePopupOpen(true);
          popupCheckedRef.current = true; // Mark as checked/shown
        }, 800);
      }
    } else {
      // Balance is not 0, ensure popup is closed and clear any pending timeout
      if (checkTimeoutRef.current) {
        clearTimeout(checkTimeoutRef.current);
        checkTimeoutRef.current = null;
      }
      if (lowBalancePopupOpen) {
        setLowBalancePopupOpen(false);
      }
      popupCheckedRef.current = false;
    }

    return () => {
      if (checkTimeoutRef.current) {
        clearTimeout(checkTimeoutRef.current);
      }
    };
  }, [path, dispatch, wallets, lowBalancePopupOpen]);

  const postLoginAlertPaths = ["/home", "/sports", "/casino", "/site"];
  const shouldPostLoginAlerts = postLoginAlertPaths.some(
    (p) => path === p || path.startsWith(p + "/")
  );
  const userIdEmpty = !(detailUser?.UserId?.trim());
  const telegramWebAccountLinkUrl = (detailUser?.telegramWebAccountLinkUrl || "").trim();
  const passwordlessCanShow =
    shouldPostLoginAlerts &&
    !demoUser() &&
    browserChannel !== "TG" &&
    Boolean(telegramWebAccountLinkUrl);

  useEffect(() => {
    if (
      !(userIdEmpty && passwordlessCanShow) ||
      sessionStorage.getItem("emptyUserIdAlertDismissed") === "true"
    ) {
      setUserIdReveal(false);
      return;
    }
    const t = window.setTimeout(() => setUserIdReveal(true), 500);
    return () => {
      window.clearTimeout(t);
      setUserIdReveal(false);
    };
  }, [shouldPostLoginAlerts, userIdEmpty, passwordlessCanShow, path, postLoginAlertTick]);

  const decodeBase64 = (base64: string) => {
    try {
      const decodedString = atob(base64); // Decode Base64
      return JSON.parse(decodedString); // Convert to JSON
    } catch (error) {
      console.error("Error decoding Base64:", error);
      return null;
    }
  };

  useEffect(() => {
    (async () => {
      const tg = (window as any)?.Telegram?.WebApp;
      tg?.ready();

      const initData = (window as any)?.Telegram?.WebView?.initParams
        ?.tgWebAppData;

    const encodedUrl = window.location.href;
    const pageUrl = decodeURIComponent(encodedUrl);
    const url = new URL(pageUrl);

      const userData: TelegramUser = tg?.initDataUnsafe?.user;
      if (userData) {
        setUser(userData);
      }

      const userId = userData?.id;
      if (key && userId) {
        const existingKey = sessionStorage.getItem("userKey");
        const newKey = `${key}-${userId}`;
        if ((existingKey !== newKey) && (newKey?.split("-")?.length > 1)) {
          sessionStorage.setItem("userKey", newKey);
        }
      }

       let webStartApp: string | null = ""
      let tgStartParam: string | null = null;
      if (initData) {
        tgStartParam = new URLSearchParams(initData).get("start_param");
      }
      if (sessionStorage.getItem("startapp")) {
        webStartApp = sessionStorage.getItem("startapp");
      }
      let startParam = webStartApp || tgStartParam;


      let encoded: string | null = null;
         encoded = await dispatch(getRefId(startParam) as any);


         if (startParam && startParam.length > 8) {
          encoded = startParam;
        }
  
      
      if (webStartApp) {
        sessionStorage.removeItem("startapp");
      }
      if (encoded) {
        const jsonData = decodeBase64(encoded);

        if (jsonData && jsonData.page) {
          const { page, ...rest } = jsonData;

          switch (page.toLowerCase()) {
            case "event":
              if (rest.id && rest.name && rest.lobby) {
                navigate(`/events/${btoa(`${rest.id}#${rest.name}#${rest.lobby}`)}`);
              }
              break;

            case "market":
              if (rest.id && rest.lobby) {
                const marketPath = rest.lobby.toUpperCase() === "SPORTSBOOK"
                  ? `/sb-markets/${btoa(`${rest.id}`)}`
                  : `/markets/${btoa(`${rest.id}`)}`;
                sessionStorage.setItem("previousPath", "/sports");
                navigate(marketPath);
              }
              break;

            case "customersupport":
              navigate(`/customersupport`)
              break;
            case "bonus":
              navigate("/wallet", { state: {bpCategory: rest?.bonus_category, bpType: rest?.bonus_type, tId: rest?.transaction_id, amount: rest?.amount, curType: rest?.currency?.type, curCategory: "", dateRange: rest?.date_range as DateRange | undefined, tab: "bonus", policyId: rest?.bonus_policy_id } });
              break;
            case "ticket-details":
              navigate("/ticket-details", { state: { ticketId: rest?.ticketId } });
              break;
            case "playgame": {
              const playPath = `/play/${btoa(`${rest?.id}:${rest?.id}:${rest?.tgProviderId}:${rest?.provider}:${rest?.subProvider}:${rest?.type}:${rest?.category}:${rest?.tableId ? rest?.tableId : ""}:${false}:${false}:${rest?.fantastyMetaData}`)}`;
              if (shouldShowWagerNotice(rest?.is_wager)) {
                setPendingWagerGameLink(playPath);
                setShowWagerNotice(true);
              } else {
                navigate(playPath);
              }
              break;
            }
            case "home":
              navigate(`/home`)
              break;
            case "casino":
              navigate(`/casino`)
              break;
            case "sports":
              navigate(`/sports`)
              break;
            case "site":
              navigate(`/promotions`, { state: { Pagetab: "site" } })
              break;
            case "raffles": {
              const restRec = rest as Record<string, unknown>;
              const bonusCategory = String(restRec?.bonus_category ?? "").trim().toUpperCase();
              let raffleId: string | undefined;
              if (bonusCategory === "RAFFLE") {
                const pid = restRec?.bonus_policy_id;
                if (pid != null && String(pid).trim() !== "") {
                  raffleId = String(pid).trim();
                }
              }
              if (!raffleId) {
                const rid = rest?.raffleId ?? restRec?.raffle_id;
                if (rid != null && String(rid).trim() !== "") {
                  raffleId = String(rid).trim();
                }
              }
              navigate(`/promotions`, {
                state: {
                  Pagetab: "raffles",
                  ...(raffleId ? { raffleId } : {}),
                },
              });
              break;
            }
            case "wallet": {
              const wantsSpin = ["tab", "Pagetab", "walletTab", "activeTab"].some(
                (key) => String((rest as Record<string, unknown>)?.[key] ?? "").toLowerCase() === "spin"
              );
              if (wantsSpin) {
                navigate(`/wallet`, { state: { tab: "spin" } })
              } else {
                navigate(`/wallet`)
              }
              break;
            }
            case "promotions":
              navigate(`/promotions`, { state: { Pagetab: "promotions" } })
              break;
            case "spin":
              navigate(`/wallet`, { state: { tab: "spin" } })
              break;
            case "providergames":
              const prov = {
                provider: rest?.provider,
                subProvider: rest?.subProvider,
                tgProviderId: rest?.tgProviderId,
                thumbnail: rest?.thumbnail,
              }
              sessionStorage.setItem("previousPath", "/casino");
              navigate("/providergames", { state: { prov } });
              break;
            case "profilepage":
              sessionStorage.setItem("previousPath", "/profile");
              if (rest?.profileOption) {
                switch (rest?.profileOption) {
                  case "myprofile":
                    navigate(`/myprofile`)
                    break;
                  case "transactions":
                    navigate(`/transactions`)
                    break;
                  case "accountstatement":
                    navigate(`/account-statement`)
                    break;
                  case "faq":
                    navigate(`/faq`)
                    break;
                  case "betlist":
                    navigate(`/betlist`)
                    break;
                  case "mybrands":
                    navigate(`/whitelabel`)
                    break;
                }
              }
              break;
            default:
              console.warn("Unknown page type or missing required fields:", jsonData);
          }
        }
      }
    })();
  }, []);
  useEffect(() => {
    if (isBlocked || sessionStorage.getItem("user_blocked") === "true") {
      const timer = setTimeout(() => {
        setBlockPopupOpen(true);
      },1200);
      return () => clearTimeout(timer);
    }
  }, [isBlocked]);
  
  useEffect(() => {
    if (!apkUrl || !shouldShowApkPopup) return;
    const alreadyShown = sessionStorage.getItem("apkDownloadPopupShown") === "true";
    if (alreadyShown) return;
    
    const timer = window.setTimeout(() => {
      setApkPopupOpen(true);
    }, 900);
    
    return () => window.clearTimeout(timer);
  }, [apkUrl, shouldShowApkPopup]);

  const isUserBlockedNow =
    isBlocked || sessionStorage.getItem("user_blocked") === "true";

  useEffect(() => {
    sessionStorage.removeItem("alertHomePopupShown");

    const t = window.setTimeout(() => {
      setAlertReady(true);
    }, 1200);

    return () => window.clearTimeout(t);
  }, []);


  const pathsToShow = ["/casino", "/wallet", "/sports", "/site", "/iframe", "/myprofile", "/profile", "/transactions", "/home", "/play", "/bannerinfo", "/raffleinfo", "/providergames", "/betlist", "/account-statement", "/site-account-statement", "/customersupport", "/ticket-details", "/transaction-history-details", "/new-ticket", "/events", "/bet-details", "/wager-list", "/faq", "/privacypolicy", "/markets",
    "/sb-markets", "/see-all", "/login", "/promotions", "/notifications", "/rules", "/trustworthy", "/about", "/aml", "/responsible-gambling", "/exclusion", "/terms", "/contact", "/ipl-themes", "/whitelabel"
  ];
  
  // Paths where social media icons should be shown (only for BigWin2026 brand)
  const socialMediaPaths = ["/home", "/casino", "/sports", "/promotions"];
  const isBigWin2026Brand = BRAND_NAME?.toLowerCase() === 'bigwin2026';
  const isMomowin777Brand = BRAND_NAME?.toLowerCase() === 'momowin777';
  const shouldShowSocialIcons = (isBigWin2026Brand || isMomowin777Brand) && socialMediaPaths.some((socialPath) => path === socialPath || path.startsWith(socialPath + "/"));
  
  useEffect(() => {
    const onWagerNotice = (e: Event) => {
      const ce = e as CustomEvent<{ path?: string }>;
      const p = String(ce?.detail?.path ?? "").trim();
      if (!p) return;
      if (!shouldShowWagerNotice(false)) {
        navigate(p);
        return;
      }
      setPendingWagerGameLink(p);
      setShowWagerNotice(true);
    };
    window.addEventListener("pg:wagerNotice", onWagerNotice as EventListener);
    return () => window.removeEventListener("pg:wagerNotice", onWagerNotice as EventListener);
  }, []);

  return (
    <>
      <WagerNoticeDialog
        open={showWagerNotice}
        onCancel={() => {
          setShowWagerNotice(false);
          setPendingWagerGameLink("");
        }}
        onProceed={() => {
          if (pendingWagerGameLink) navigate(pendingWagerGameLink);
          setShowWagerNotice(false);
          setPendingWagerGameLink("");
        }}
      />

      <Backdrop
        sx={{ color: "#051314", zIndex: (theme: any) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <div className="fullWidth">
          <LoaderComponent domain={domain} />
        </div>
      </Backdrop>
      {
        !loading && (
          <>
            {path === "/" ? (
              <Navigate to="/home" replace />
            ) : path.startsWith("/play") || path.startsWith("/markets") || path.startsWith("/sb-markets") ? (
              <AppRoutes />
            ) : pathsToShow.some((validPath) => path.startsWith(validPath)) ? (
              <>
                <WalletInfo balance="0.230089" />
                <AppRoutes />
                <Footer />
                {shouldShowSocialIcons && <SocialMediaIcons siteConfig={siteConfig} />}
              </>
            ) : (
              <NoAccessPage />
            )}
          {BRAND_NAME === 'Winfast99' && (() => {
            const pointsWallet = wallets.find((wallet: any) => wallet?.walletName === "POINTS");
            return (
              <LowBalancePopup
                open={lowBalancePopupOpen}
                onClose={() => setLowBalancePopupOpen(false)}
                walletIcon={pointsWallet?.walletIcon}
              />
            );
          })()}
          <AlertHomePopup
            suppress={isUserBlockedNow || blockPopupOpen}
            onlyOnPaths={["/home", "/casino", "/sports", "/wallet","/promotions"]}
            sessionKey="alertHomePopupShown"
          />
          <EmptyUserIdPopup
            open={userIdReveal}
            linkUrl={telegramWebAccountLinkUrl}
            onClose={() => setPostLoginAlertTick((x) => x + 1)}
          />
          </>
        )
      }
      {blockPopupOpen && (
        <Dialog
          fullScreen={false}
          open={blockPopupOpen}
          onClose={() => {
            sessionStorage.removeItem("user_blocked");
            setBlockPopupOpen(false);
          }}
          PaperProps={{
            style: {
              position: 'absolute',
              top: '5rem',
            },
          }}
        >
          <div className="dialog-bg bg-inputbox-color relative p-4 min-w-[20rem]">
            <CloseIcon
              className="absolute top-3 right-3 text-white text-2xl font-semibold cursor-pointer"
              onClick={() => {
                sessionStorage.removeItem("user_blocked");
                setBlockPopupOpen(false);
              }}
            />
            <div className="text-white">
              <h2 className="text-lg font-semibold mb-2">🚫 User Blocked</h2>
              <p className="text-sm text-zinc-400 mb-4">
                User Blocked. Please contact support.
              </p>
              <div className="flex justify-between">
                <button
                  type="button"
                  className="p-2.5 w-[48%] text-sm text-white bg-error-color rounded-lg border border-error-color border-solid leading-[1.4rem]"
                  onClick={() => {
                    sessionStorage.removeItem("user_blocked");
                    setBlockPopupOpen(false);
                  }}
                >
                  OK
                </button>
                <button
                  type="button"
                  className="p-2.5 w-[48%] text-sm text-white bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem]"
                  onClick={() => {
                    sessionStorage.removeItem("user_blocked");
                    setBlockPopupOpen(false);
                    navigate("/customersupport");
                  }}
                >
                  Contact Support
                </button>
              </div>
            </div>
          </div>
        </Dialog>
      )}
      
      {apkPopupOpen && apkUrl && shouldShowApkPopup && (
        <Dialog
          fullScreen={false}
          open={apkPopupOpen}
          onClose={() => {
            sessionStorage.setItem("apkDownloadPopupShown", "true");
            setApkPopupOpen(false);
          }}
          PaperProps={{
            style: {
              position: "absolute",
              top: "5rem",
            },
          }}
        >
          <div className="dialog-bg bg-inputbox-color relative p-4 min-w-[20rem]">
            <CloseIcon
              className="absolute top-3 right-3 text-white text-2xl font-semibold cursor-pointer"
              onClick={() => {
                sessionStorage.setItem("apkDownloadPopupShown", "true");
                setApkPopupOpen(false);
              }}
            />
            <div className="text-white">
              <h2 className="text-lg font-semibold mb-2">Download our Android App</h2>
              <p className="text-sm text-zinc-400 mb-4">
                Get the app for a faster experience.
              </p>
              <div className="flex gap-2">
                <a
                  href={apkUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2.5 w-full text-sm text-white bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem] text-center no-underline"
                  onClick={() => {
                    sessionStorage.setItem("apkDownloadPopupShown", "true");
                    setApkPopupOpen(false);
                  }}
                >
                  Download APK
                </a>
                <button
                  type="button"
                  className="p-2.5 w-full text-sm text-white bg-zinc-700 rounded-lg border border-zinc-700 border-solid leading-[1.4rem]"
                  onClick={() => {
                    sessionStorage.setItem("apkDownloadPopupShown", "true");
                    setApkPopupOpen(false);
                  }}
                >
                  Not now
                </button>
              </div>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
};

function App() {

  const key = new URLSearchParams(window.location.search).get("id");
  const { initializeAuth } = useAuth();
  const [appState, setAppState] = useState({
    isLoading: true,
    isTelegramBrowser: true,
    tgInitData: null as any,
  });
  const dispatch = useDispatch<AppDispatch>();
  const [userKey, setUserKey] = useState<any>("");
  const userDetails = useSelector((state: RootState) => state.userDetails);
  const [isToken, setIsToken] = useState<any>({
    isAuth: true,
    token: "",
  });
  const [isTele, setIsTele] = useState<any>("");
  const [referal, setReferal] = useState<any>("");
  const [groupConfigResolved, setGroupConfigResolved] = useState(false);

  const authenticateUser = async (initdata: any, key: any): Promise<{ success: boolean }> => {
    const { success, token } = await initializeAuth(initdata, key);

    setAppState((prev) => ({
      ...prev,
      isLoading: !success,
    }));
    return { success: success }
  };

  useEffect(() => {
    // loadTheme();
    updateFavicon();
    updateTitle();
    updateOpenGraphTags();
    updateManifest();
    initMetaPixelIfHindu777();
    initMetaPixelIfBidexch();
    initZohoSalesIQIfShivShaktiGaming();
  }, []);

  useEffect(() => {
    (async () => {
      // Block any further startup/auth APIs if `/group-config` returns
      // a channel-specific fatal message.
      const { blocked } = (await dispatch(siteConfig() as any)) as { blocked: boolean };
      setGroupConfigResolved(true);
      if (blocked) return;

      const fetchData = async (): Promise<{ success: boolean }> => {
        try {
          const tg = (window as any)?.Telegram?.WebApp;
          tg?.ready();

          const isTG = !!tg?.initDataUnsafe?.user;
          if (isTG) {
            dispatch(setBrowser("TG"));
            let Ukey = "";
            const userData: TelegramUser = tg?.initDataUnsafe?.user;
            const userId = userData?.id;

            if (key && userId) {
              const newKey = `${key}-${userId}`;
              Ukey = newKey;
              setUserKey(newKey);
              sessionStorage.setItem("userKey", newKey || "");
            }

            const initData = (window as any)?.Telegram?.WebView?.initParams?.tgWebAppData;

            const { success } = await authenticateUser(
              initData,
              Ukey
            );

            if (initData) {
              setAppState((prev) => ({
                ...prev,
                tgInitData: initData,
              }));
            } else {
              setAppState((prev) => ({
                ...prev,
                isTelegramBrowser: false,
                isLoading: false,
              }));
            }
            return { success: success }
          }
        } catch (error) {
          console.log("Error while fetching the init data", error);
          setAppState((prev) => ({
            ...prev,
            isTelegramBrowser: false,
            isLoading: false,
          }));
        }

        return { success: false }
      };

      const { success } = await fetchData();

      if (success) {
        sessionStorage.removeItem('lowBalancePopupClosed'); // Reset popup flag on login
        sessionStorage.removeItem("emptyUserIdAlertDismissed");
        dispatch(setIsLoggedIn(true))
      }
    })();
  }, []);

  useEffect(() => {
    const tg = (window as any)?.Telegram?.WebApp;
    tg?.ready();

    const isTG = !!tg?.initDataUnsafe?.user;
    if (isTG) {
      setIsTele("TG");
      dispatch(setBrowser("TG"));
    } else {
      const searchParams = new URLSearchParams(window.location.search);
      const referral = searchParams.get("referral");
      const startapp = searchParams.get("startapp");
      if (referral) {
        setReferal(referral);
      }
      if (startapp) {
        sessionStorage.setItem("startapp", startapp);
        }
      setIsTele("Web")
    }

    // setIsTele("TG");
  }, [])

  useEffect(() => {
    if (isTele !== 'TG') {
      // Restore isLoggedIn from sessionStorage
      const storedIsLoggedIn = sessionStorage.getItem("isLoggedIn");
      if (storedIsLoggedIn === "true") {
        dispatch(setIsLoggedIn(true));
      }
    }
  }, [dispatch, isTele]);

  useEffect(() => {
    if (isTele !== 'TG') {
      // Persist isLoggedIn to sessionStorage
      if (userDetails && userDetails.isLoggedIn) {
        sessionStorage.setItem("isLoggedIn", "true");
      } else {
        sessionStorage.setItem("isLoggedIn", "false");
      }
    }
  }, [userDetails, isTele]);

  const fatalMessage = (userDetails.groupConfigFatalMessage || "").trim();
  const [isShortFatalMessage, setIsShortFatalMessage] = useState<boolean>(false);
  const fatalMessageMeasureRef = useRef<HTMLParagraphElement | null>(null);

  useLayoutEffect(() => {
    if (!fatalMessage) {
      setIsShortFatalMessage(false);
      return;
    }

    const compute = () => {
      const el = fatalMessageMeasureRef.current;
      if (!el) return;

      const cs = window.getComputedStyle(el);
      const lineHeight = parseFloat(cs.lineHeight || "");
      if (!Number.isFinite(lineHeight) || lineHeight <= 0) return;

      const height = el.getBoundingClientRect().height;
      const lines = Math.max(1, Math.round(height / lineHeight));
      setIsShortFatalMessage(lines <= 1);
    };

    const rafId = window.requestAnimationFrame(compute);
    window.addEventListener("resize", compute);

    return () => {
      window.cancelAnimationFrame(rafId);
      window.removeEventListener("resize", compute);
    };
  }, [fatalMessage]);

  return (
    <Router>
      <div className="flex flex-col mx-auto w-full bg-custom-bg bg-repeat bg-auto bg-cover min-h-screen gradient-div">
        <div className="flex flex-col w-full">

          {fatalMessage ? (
            <div className="flex min-h-screen w-full items-center justify-center px-4 py-10 sm:px-6 relative">
              <div
                role="alert"
                className={`relative w-full rounded-2xl border border-solid border-border-color bg-inputbox-color text-center shadow-2xl ${
                  isShortFatalMessage
                    ? "max-w-xs px-5 py-5 sm:px-6 sm:py-6"
                    : "max-w-sm px-5 py-6 sm:px-7 sm:py-7"
                }`}
              >
                <div
                  className={`mx-auto flex items-center justify-center rounded-full border border-solid border-error-color/40 bg-error-color/10 text-error-color ${
                    isShortFatalMessage ? "mb-3 h-12 w-12" : "mb-4 h-12 w-12"
                  }`}
                  aria-hidden
                  style={{
                    borderColor: "#d9534f",
                    backgroundColor: "rgba(217, 83, 79, 0.18)",
                    boxShadow: "0 0 0 2px rgba(217, 83, 79, 0.22), 0 6px 20px rgba(0,0,0,0.2)",
                  }}
                >
                  <span
                    className={`font-bold leading-[1] ${
                      isShortFatalMessage ? "text-3xl" : "text-2xl"
                    }`}
                    style={{ lineHeight: "1", color: "#d9534f" }}
                  >
                    !
                  </span>
                </div>
                <h1 className={`font-semibold leading-snug text-white ${isShortFatalMessage ? "mb-2 text-xl" : "mb-3 text-lg sm:text-xl"}`}>
                  Notice
                </h1>
                <p className={`whitespace-pre-wrap text-center text-zinc-300 ${isShortFatalMessage ? "text-lg font-medium leading-7" : "text-[15px] leading-relaxed"}`}>
                  {fatalMessage}
                </p>
                <div
                  className={`border-t border-solid border-border-color ${
                    isShortFatalMessage ? "mt-4 pt-3" : "mt-5 pt-4"
                  }`}
                >
                  <p className="text-sm text-zinc-500">
                    Please try again later or contact support if you need help.
                  </p>
                </div>
              </div>
              <div
                aria-hidden
                className="pointer-events-none absolute left-1/2 top-0 -translate-x-1/2 w-full max-w-xs px-5 py-5 sm:px-6 sm:py-6 opacity-0"
              >
                <p
                  ref={fatalMessageMeasureRef}
                  className="whitespace-pre-wrap text-center text-lg font-medium leading-7 text-zinc-300"
                >
                  {fatalMessage}
                </p>
              </div>
            </div>
          ) : (!groupConfigResolved || isTele === '') ? (
            <LoaderComponent domain={domain} />
          ) : userDetails.logout ? (
            isTele === 'Web' ? (
              <Routes>
                <Route path="/login" element={<LoginWrapper referalCode={referal} />} />
                <Route path="/register" element={<RegisterWrapper referalCode={referal} />} />
                <Route path="/sitemap.xml" element={<Sitemap />} /> 
                <Route path="/*" element={<Navigate to="/login" replace />} />
              </Routes>
            ) : (
              <Logout />
            )
          ) : userDetails.isLoggedIn ? (
            <ConditionalRoutes />
          ) : isTele === 'TG' ? (
            <LoaderComponent domain={domain} />
          ) : (
            <Routes>
              <Route path="/login" element={<LoginWrapper referalCode={referal} />} />
              <Route path="/register" element={<RegisterWrapper referalCode={referal} />} />
              <Route path="/sitemap.xml" element={<Sitemap />} /> 
              <Route path="/*" element={<Navigate to="/login" replace />} />
            </Routes>
          )}

        </div>
      </div>
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </Router>
  );
}

export default App;
